module.exports = __webpack_public_path__ + "img/idea.f3cc7f29.svg";